import Vue from 'vue';
import Router from 'vue-router';

import routes from './routes';

Vue.use(Router);

export default new Router({
  routes,
  mode: 'history',
  scrollBehavior() {
    const targetDOM = document.querySelector('#platform');
    if (targetDOM) targetDOM.scrollTop = 0;
  },
});
